import * as React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import InspirationItem from '../../components/inspiration/InspirationItem';
import Layout from '../../components/layouts/core';
import SeriesPage from '../../components/series/SeriesPage';

import newYorkCity from '../../data/CollectionItems/newYorkCity';

import newYorkCityCarouselPiece from '../../data/CarouselPieces/newYorkCityCarouselPiece';

import getImagesFromNodes from '../../utils/getImagesFromNodes';

export const pageQuery = graphql`
  query {
    allFile(filter: { relativePath: { regex: "/new-york-city-mondrian-print/" } }) {
      nodes {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(width: 600, height: 600, placeholder: DOMINANT_COLOR, formats: [AUTO, WEBP, AVIF])
        }
      }
    }
  }
`;

const ogDescription = `Boogie-Woogie is an NFT collection from Dandy Lines.
In our Run 1 Mondrian Series, we pay homage to the collection's inspiration: Piet Mondrian.
We pulled a later work that incorporates only red, yellow, blue, and white, and use it to create
a visually striking composition that harkens the later works of Mondrian.`;

const RunOneMondrianPage = ({ data }) => {
  const images = getImagesFromNodes(data.allFile.nodes);

  return (
    <>
      <Helmet>
        <title>Boogie-Woogie | Run 1 Mondrian Series</title>
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:site' content='@BoogieWoogieNFT' />
        <meta name='twitter:creator' content='@ics_jim' />
        <meta property='og:url' content='https://boogie-woogie.io/series/run-1-mondrian' />
        <meta property='og:title' content='Boogie-Woogie | Run 1 Mondrian Series' />
        <meta property='og:type' content='website' />
        <meta property='og:description' content={ogDescription} />
        <meta property='og:image' content='https://sale.boogie-woogie.io/boogie-woogie-auction-site-run-one.png' />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='630' />
      </Helmet>
      <Layout>
        <SeriesPage details={newYorkCity.details} seriesName='Run 1 Mondrian Series' images={images}>
          <InspirationItem
            ReferenceImage={newYorkCity.ReferenceImage}
            details={newYorkCity.details}
            seriesPage={newYorkCity.seriesPage}
            piece={newYorkCityCarouselPiece}
          />
        </SeriesPage>
      </Layout>
    </>
  );
};

export default RunOneMondrianPage;
